import React from "react";
import { SpecialSectionCards } from "../../..";
import { welcomeData } from "../../../../assets/data/aboutUsData";

export default function WelcomeSection(props) {
	return (
		<section className="welcome-section no-pt no-px-md">
			<SpecialSectionCards data={welcomeData} navigate />
		</section>
	);
}
